import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';

const MarkdownViewer = ({ filePath }) => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch(`/docs/${filePath}.md`)
      .then((response) => response.text())
      .then((text) => setContent(text))
      .catch((error) => console.error('Error loading markdown:', error));
  }, [filePath]);

  return (
    <div className="prose max-w-none p-6">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};

export default MarkdownViewer;
